<template>
  <Modal :show-modal="show" @close="closeModal">
    <template #header>
      <div class="modal__header">
        <TitleRegular :title="$t('folders.remove.title')" />
      </div>
    </template>
    <template #body>
      <LocalLoader :is-medium="true" :loading="loading" />
      <TextRegular>
        <i18n-t keypath="folders.remove.confirm" tag="p">
          <template #folderName>
            <b>{{ folderName }}</b>
          </template>
        </i18n-t>
        <p>
          {{ $t('folders.remove.warning_text') }}
        </p>
      </TextRegular>
    </template>
    <template #footer>
      <BtnsWrapper>
        <BtnDanger :title="$t('shared.button.delete')" @click="handleDelete" />
        <BtnSecondary :title="$t('shared.button.cancel')" @click="closeModal" />
      </BtnsWrapper>
    </template>
  </Modal>
</template>
<script setup>
import Modal from '@/components/shared/Modal'
import BtnDanger from '@/components/shared/btn/BtnDanger'
import BtnSecondary from '@/components/shared/btn/BtnSecondary'
import BtnsWrapper from '@/components/shared/btn/BtnsWrapper'
import TextRegular from '@/components/shared/font/text/TextRegular'
import TitleRegular from '@/components/shared/font/title/TitleRegular'
import LocalLoader from '@/components/shared/loaders/LocalLoader'
import i18n from '@/i18n'
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const $t = i18n.t

const emit = defineEmits(['close'])
const props = defineProps({
  folderName: String,
  folderId: String,
  show: Boolean
})

const loading = computed(() => store.state.loading.loading)

const deleteFolder = (payload) =>
  store.dispatch('workspace/deleteFolder', payload)

function closeModal() {
  emit('close')
}
async function handleDelete() {
  try {
    await deleteFolder(props.folderId)
  } finally {
    closeModal()
  }
}
</script>
<style lang="scss" scoped>
.tiersList {
  margin-top: 3rem;
  &__list {
    border-top: 1px solid #e6e9f0;

    &--item {
      display: grid;
      position: relative;
      grid-template-columns: 30% 35% 35%;
      grid-template-rows: auto;
      grid-column-gap: 10px;
      border-bottom: 1px solid #e6e9f0;
      padding: 10px;
      color: #454a5b;
      border-radius: 2px;
      z-index: 1;
      &.selected {
        background: $blue-30;
      }
      .listItem {
        display: flex;
        flex-direction: row;
        margin-bottom: 1rem;
        &:nth-child(2),
        &:nth-child(3) {
          justify-content: center;
        }
        :deep(.listItem__label) {
          display: none !important;
        }
      }
      @include mobileLandscape {
        grid-template-columns: 50% 25% 25%;
      }
    }
    .noResult {
      margin-top: 3rem;
    }
  }

  &__subject {
    padding: 0 10px;
    display: grid;
    grid-template-rows: 1fr;
    grid-column-gap: 10px;
    padding-bottom: 5px;
    grid-template-columns: 30% 35% 35%;
    @include mobileLandscape {
      grid-template-columns: 50% 25% 25%;
    }
    &__item {
      font-size: 12px;
      font-weight: 700;
      color: #454a5b;
      padding-bottom: 10px;
      &:nth-child(2),
      &:nth-child(3) {
        text-align: center;
      }
    }
  }
}
</style>
